var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('button',{staticClass:"nea-link",on:{"click":_vm.toggleImprint}},[_vm._v(" "+_vm._s(this.$t("general.imprintfield"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }